export default {"src":"/pro/_next/static/media/scr.f85a8b1d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};